module.exports = __webpack_public_path__ + "static/media/21_portrait.c7e4cba3.jpg";